import React from "react";
import "./App.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import WhyChooseUs from "./components/WhyChooseUs";
import CandidateProfile from "./components/CandidateProfile";
import Locations from "./components/Locations";
import Careers from "./components/Careers";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <About />
        <WhyChooseUs />
        <Careers />
        <CandidateProfile />
        <Locations />
        <Footer />
      </main>
    </div>
  );
}

export default App;
